export default "__VITE_ASSET__Bza$XXtV__"